export default __webpack_public_path__ + "static/media/Screenshot_18.817d8b6f.png";